import { Box } from '@mui/material';
import { NotePlusOutline } from 'mdi-material-ui';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import styles from '../../vigofiledrop.module.css';

interface DropZoneBackgroundProps {
  required: boolean | undefined;
  dropzoneTextColor: string;
  description: string;
  maxFileSize?: number;
  acceptedFileTypes?: Record<string, string[]>;
}

const DropZoneBackground = ({
  required,
  dropzoneTextColor,
  description,
  maxFileSize,
  acceptedFileTypes
}: DropZoneBackgroundProps) => {
  return (
    <>
      {required && (
        <VigoTypography
          value="* required"
          sx={{
            position: 'absolute',
            left: '5px',
            top: '5px',
            color: theme => (theme.palette.mode === 'light' ? '#626679' : '#fff')
          }}
        />
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          flex: '1 1 auto',
          minHeight: 0,
          padding: '12px 20px'
        }}>
        <NotePlusOutline sx={{ color: dropzoneTextColor, width: '1.429rem' }} className={styles.addFilesIcon} />
        <VigoTypography value={description} sx={{ color: dropzoneTextColor, fontSize: '1.143rem' }} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '100%',
          flexShrink: 0,
          padding: '0px 20px 12px 20px'
        }}>
        {maxFileSize && (
          <VigoTypography
            disableTranslation
            value={`Max file size: ${maxFileSize}MB.`}
            sx={{
              color: theme => (theme.palette.mode === 'light' ? '#626679' : '#fff'),
              fontSize: '0.857rem'
            }}
          />
        )}
        {acceptedFileTypes && (
          <VigoTypography
            disableTranslation
            value={`Accepted file types: ${Object.values(acceptedFileTypes).flat().join(', ')}`}
            sx={{
              color: theme => (theme.palette.mode === 'light' ? '#626679' : '#fff'),
              fontSize: '0.857rem'
            }}
          />
        )}
      </Box>
    </>
  );
};

export default DropZoneBackground;
